import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrderWithFlavorService } from '../services/orderwithflavor.service';
import { Shift } from '../models/flavor.model';
import { Restaurant } from '../models/restaurant.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrderWithFlavorStore {
  private _flavorShifts$ = new BehaviorSubject<Shift[]>([]);
  private _restaurants$ = new BehaviorSubject<Restaurant[]>([]);
  private _shift = new BehaviorSubject<Shift>(null);

  public flavorShifts$: Observable<Shift[]> = this._flavorShifts$.asObservable();
  public restaurants$: Observable<Restaurant[]> = this._restaurants$.asObservable();

  constructor(private orderWithFlavorService: OrderWithFlavorService) {}

  get shift(): Shift {
    return this._shift.getValue();
  }

  set shift(value: Shift) {
    this._shift.next(value);
  }

  public loadShifts(vanityLink: string, restaurants: Restaurant[]): void {
    this.orderWithFlavorService.getShifts(vanityLink).subscribe(
      (data) => {
        this._flavorShifts$.next(data);
        this.updateRestaurantsWithLocations(data, restaurants);
      }
    );
  }

  private updateRestaurantsWithLocations(flavorShifts: Shift[], restaurants: Restaurant[]): void {
    let updatedRestaurants = [];
    for (const shift of flavorShifts) {
      const restaurant = restaurants.find((r) => r.locationId === shift.kyoo_location_id);
      if (restaurant) {
        let nextRestaurant = { ...restaurant, address: { ...restaurant.address }};
        nextRestaurant.address.addressLine = shift.location_id.street_number_and_name;
        if(nextRestaurant.address.coordinates){
          nextRestaurant.address.coordinates.latitude = parseFloat(shift.location_id.area.latitude);
          nextRestaurant.address.coordinates.longitude = parseFloat(shift.location_id.area.longitude);
        }
        nextRestaurant.name = shift.location_id.name;
        if (!updatedRestaurants.find((r) => r.name === nextRestaurant.name)) {
          updatedRestaurants.push(nextRestaurant);
        }
      }
    }
    this._restaurants$.next(updatedRestaurants);
  }

  public getRestaurantById(id: string, address: string): Observable<Restaurant> {
    return this.restaurants$.pipe(
      map(restaurants => restaurants.find(item => item.locationId === id && item.address.addressLine === address))
    );
  }
}
